import React from "react";
import { deviceDetect } from "react-device-detect";
import { Box, Typography } from "@mui/material";
import IOSComponent from "./IOSComponent";
import AndroidGuide from "./AndroidGuide";

function MobileComponent() {
  const [osN, setOsN] = React.useState("");

  React.useEffect(() => {
    let data = deviceDetect();
    setOsN(data.os);
  }, [osN]);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
        Install Cartube App
      </Typography>
      <Box sx={{ mt: 2 }}>
        {osN === "Android" ? <AndroidGuide /> : <IOSComponent />}
      </Box>
    </Box>
  );
}

export default MobileComponent;
